export const FLIPBOOK_DESKTOP_BREAKPOINT = 900
export const FLIPBOOK_MIN_ZOOM = 1
export const FLIPBOOK_MAX_ZOOM = 3
export const FLIPBOOK_ZOOM_STEP = 0.25
export const FLIPBOOK_PAGE_TURN_DURATION_MS = 720
export const FLIPBOOK_SWIPE_THRESHOLD_PX = 48
